import ReportNoveltySignature from './ReportNoveltySignature';
export default ReportNoveltySignature;
